import React, { useEffect, useState } from "react";
import {
  classesURL,
  reportsClassesURL,
  reportsURL,
  studentURL,
} from "../../Hooks/URL";
import useFetch from "../../Hooks/useFetch";
import { useLocation, useParams } from "react-router-dom";
import ClassFeedback from "../../Templates/Reports/ClassFeedback/ClassFeedback";
import useEdit from "../../Hooks/useEdit";
import useSave from "../../Hooks/useSave";
import useFetchWhen from "../../Hooks/useFetchWhen";
import AddClassFeedback from "../../Templates/Reports/AddClassFeedback/AddClassFeedback";
import usePut from "../../Hooks/usePut";

function AddClassFeedbackPage({ Edit = false }) {
  let { id, report_id, student_id, feedback_id } = useParams();
  const [newObject, setNewObject] = useState({});
  const [attributes, setAttributes] = useState([]);
  const [report, setReport] = useState(null);
  const [student, setStudent] = useState(null);
  const [Class, setClass] = useState({});
  const studentUrl = `${studentURL}/${student_id}`;

  const { data, loading, error } = useFetchWhen(
    `${classesURL}/${id}/class-feedbacks/${report_id}/feedbacks/create`,
    !Edit
  );
  const {
    data: studentData,
    loading: studentLoading,
    error: studentError,
  } = useFetch(studentUrl);
  const {
    data: reportData,
    loading: reportLoading,
    error: reportError,
  } = useFetchWhen(
    `${classesURL}/${id}/class-feedbacks/${report_id}/feedbacks/${feedback_id}`,
    Edit
  );
  const {
    data: classData,
    loading: classLoading,
    error: classError,
  } = useFetch(`${classesURL}/${id}`);

  const [goEdit, setGoEdit] = useState(false);
  const { loading: editLoading } = usePut({
    url: `${classesURL}/${id}/class-feedbacks/${report_id}/feedbacks/${feedback_id}`,
    goEdit,
    setGoEdit,
    newObject,
    navigateAfter: `/classes/${id}/reports/${report_id}`,
  });

  const [goSave, setGoSave] = useState(false);
  const { saveState, loading: addLoading } = useSave({
    url: `${classesURL}/${id}/class-feedbacks/${report_id}/feedbacks`,
    goSave,
    setGoSave,
    newObject,
    navigateAfter: `/classes/${id}/reports/${report_id}`,
  });

  useEffect(() => {
    if (!loading && !error && data) {
      setAttributes(data.data);
    }
  }, [data, loading, error]);

  useEffect(() => {
    if (!reportLoading && !reportError && reportData) {
      setReport(reportData?.data);
    }
  }, [reportData, reportLoading, reportError]);

  useEffect(() => {
    if (!studentLoading && !studentError && studentData) {
      setStudent(studentData?.data);
    }
  }, [studentData, studentLoading, studentError]);

  useEffect(() => {
    if (!classLoading && !classError && classData) {
      setClass(classData?.data);
    }
  }, [classData, classLoading, classError]);

  return (
    <AddClassFeedback
      student={student}
      report={report}
      Class={Class}
      reportLoading={reportLoading}
      attributes={attributes}
      studentLoading={studentLoading}
      loading={Edit ? reportLoading : loading}
      setGoSave={setGoSave}
      classId={id}
      studentId={student_id}
      addLoading={addLoading}
      setNewObject={setNewObject}
      Edit={Edit}
      editLoading={editLoading}
      setGoEdit={setGoEdit}
    />
  );
}

export default AddClassFeedbackPage;
